import {
  ItemListRendererProps,
  renderFilteredItems,
} from '@blueprintjs/select';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { Project } from 'src/store/state/projects';

export const ProjectCards: React.VFC<ItemListRendererProps<Project>> = (
  projectListProps
) => (
  <div className="sd-project-cards" data-testid={TEST_IDS.home.projectCards}>
    {renderFilteredItems(projectListProps)}
  </div>
);
